<template>
  <main class="min-h-[100dvh]">
    <slot />
  </main>
</template>

<script setup>

</script>
